<!-- <app-dashboard></app-dashboard> -->
<router-outlet></router-outlet>
<!-- <app-size-detector></app-size-detector> -->